import React, { useState } from 'react';
import AttendanceList from './AttendanceList';

const DashboardTable = ({ attendanceRecords }) => {
  const [filter, setFilter] = useState('all');
  const [dateFilter, setDateFilter] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  const filteredRecords = attendanceRecords.filter(record => {
    const matchesFilter = filter === 'all' || record.type === filter;
    const matchesDate = !dateFilter || record.date === dateFilter;
    const matchesSearch = !searchTerm || 
      record.employeeName.toLowerCase().includes(searchTerm.toLowerCase()) || 
      record.dni.includes(searchTerm);
    return matchesFilter && matchesDate && matchesSearch;
  });

  return (
    <div className="animate-fade-in-up space-y-6">
      <div className="flex flex-col sm:flex-row gap-3">
        <select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="px-4 py-2.5 bg-slate-900 border border-slate-850 text-slate-200 rounded-xl focus:outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/25 transition-all text-sm"
        >
          <option value="all">Todos los registros</option>
          <option value="entrada">Entradas</option>
          <option value="salida">Salidas</option>
        </select>
        <input
          type="date"
          value={dateFilter}
          onChange={(e) => setDateFilter(e.target.value)}
          className="px-4 py-2.5 bg-slate-900 border border-slate-850 text-slate-200 rounded-xl focus:outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/25 transition-all text-sm"
        />
        <input
          type="text"
          placeholder="Buscar por Nombre o DNI..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="flex-1 px-4 py-2.5 bg-slate-900 border border-slate-850 text-slate-200 rounded-xl focus:outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/25 transition-all text-sm"
        />
      </div>
      <AttendanceList attendanceRecords={filteredRecords} />
    </div>
  );
};

export default DashboardTable;
